import React, { Component } from "react";
import Slider from "react-slick";
import { generalFormStyles } from './StyleObjects/generalStyles';
import { makeStyles } from "@material-ui/styles";
import { Grid, Collapse, Typography } from '@material-ui/core'
import { GitHubIcon } from '../icons/GitHubIcon';
import loadable from '@loadable/component';
const useFormStyles = makeStyles(generalFormStyles);
const SliderLoadable = loadable.lib(() => import('react-slick'), {
  resolveComponent: slider => slider.default || slider,
})
export function AcademicProjects() {

  const classes = useFormStyles();

  const settings = {
    arrow: true,
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 1500,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  return (
    <Grid className={classes.projects}>
      <h1 > ACADEMIC PROJECTS </h1>
      <SliderLoadable>
        {Slider => (<Slider {...settings} className={classes.projectInformation}>
          <Grid container className={`${classes.shareIcon} ${classes.subProjectInformation}`}>
            <h2>Web Search Engine</h2>
            <h3>•	Implemented concepts such as Tries, quick select, heap sort, web crawler, edit distance for word suggestions, pattern matching algorithm – Boyer Moore Algorithm</h3>
            <h3>•	Rendered 10,000+ webpages by developing Web crawler and using Jsoup library</h3>
          </Grid>
          <Grid container className={`${classes.shareIcon} ${classes.subProjectInformation}`}>
            <h2>The Task Manager App</h2>
            <h3>•	Created a REST API that manages tasks of various users.</h3>
            <h3>•	Developed features such as user authentication, file upload, email notifications</h3>
            <h3>•	Stored various user data using MongoDB</h3>
          </Grid>
          <Grid container className={`${classes.shareIcon} ${classes.subProjectInformation}`}>
            <h2>Product Recommendation System</h2>
            <h3>•	Led a team of 4 to develop a product recommendation feature similar to e-commerce website</h3>
            <h3>•	Developed standalone Java web application (Spring Boot), connected with graph database Neo4j</h3>
          </Grid>
          <Grid container className={`${classes.shareIcon} ${classes.subProjectInformation}`}>
            <h2>EventMine</h2>
            <h3>•	In a team of 4, developed an event experience system for great user experience</h3>
            <h3>•	Implemented core functionality such as adding events, registration, listing events and attendees</h3>
            <h3>•	Designed layout of the application for basic components and features.</h3>
          </Grid>
        </Slider>)}
      </SliderLoadable>
    </Grid>
  );
}
